import React from 'react';
import { Download } from 'lucide-react';
import { exportToJSON, exportToCSV } from '../utils/helpers';

const ExportMenu = ({ questions, onClose }) => {
  const handlePrint = () => {
    window.print();
    onClose();
  };

  const handleJSONExport = () => {
    exportToJSON(questions);
    onClose();
  };

  const handleCSVExport = () => {
    exportToCSV(questions);
    onClose();
  };

  return (
    <div className="export-menu">
      <button onClick={handlePrint} className="export-menu-item">
        <Download size={18} style={{ color: '#3b82f6' }} />
        <span>Print/PDF</span>
      </button>
      <button onClick={handleJSONExport} className="export-menu-item">
        <Download size={18} style={{ color: '#10b981' }} />
        <span>Export JSON</span>
      </button>
      <button onClick={handleCSVExport} className="export-menu-item">
        <Download size={18} style={{ color: '#8b5cf6' }} />
        <span>Export CSV</span>
      </button>
    </div>
  );
};

export default ExportMenu;